import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import axios from 'axios';
import { getSum } from '@/utils/utils';
import moment from 'moment';
import { drillDownAPI } from '@/providers/apis/drill-down/drill-down';
import { CompetencyModel } from '@/models/drill-down/competency';
import { PerformanceModel } from '@/models/drill-down/performance';
import { SubjectModel } from '@/models/drill-down/subject';
import { DrillDownModel } from '@/models/drill-down/drill-down';
import { numberFormat } from '@/helpers/number-format';
import { formatTime as formatTimeInMilliSec } from '@/utils/date';
import DrilldownTimespentPullup from '@/components/pull-up/drilldown-ts-pullup/drilldown-ts-pullup';
import { TimespentData, ClassTimespentData } from '@/models/groups/timespent';
import GuestUserPop from '@/components/guest-user-pop/guest-user-pop';
import { sessionService } from '@/providers/services/auth/session';
import ClassProgressReport from '../../class-progress-report/class-progress-report';
import { SubjectsModel } from '@/models/groups/subjects';
import { STUDENT_TIMESPENT_DATA } from '@/utils/constants';

@Component({
  name: 'network-timespent-card',
  components: {
    'material-icon': GoogleMaterialIcon,
    'drilldown-timespent-pullup': DrilldownTimespentPullup,
    'guest-popup': GuestUserPop,
    'class-report': ClassProgressReport,
  },
})

export default class NetworkTimespentCard extends Vue {

  // ------------------------------------------------------------
  // Actions
  private get avgTimespent() {
    return this.groupType === 'class' ?
      this.classTimespentData && this.classTimespentData.overallStats ?
        this.classTimespentData.overallStats.overallAverageTimespent : 0 :
      this.timespentData && this.timespentData.overallStats ?
        this.timespentData.overallStats.overallAverageTimespent : 0;
  }

  private get isGuestUser() {
    return this.$access.isGuestUser('guest', 'guest');
  }
  private get activeStudent() {
    if (this.$access.isDemoGroup && STUDENT_TIMESPENT_DATA[this.groupType]) {
      return STUDENT_TIMESPENT_DATA[this.groupType].activeStudent;
    }
    return this.groupType === 'class' ?
      this.classTimespentData && this.classTimespentData.overallStats ?
        this.classTimespentData.overallStats.activeStudents : {} :
      this.timespentData && this.timespentData.overallStats ?
        this.timespentData.overallStats.activeStudents : {};
  }


  private get totalStudent() {
    if (this.$access.isDemoGroup && STUDENT_TIMESPENT_DATA[this.groupType]) {
      return STUDENT_TIMESPENT_DATA[this.groupType].students;
    }
    return this.groupType === 'class' ?
      this.classTimespentData && this.classTimespentData.overallStats ?
        this.classTimespentData.overallStats.totalStudents : {} :
      this.timespentData && this.timespentData.overallStats ?
        this.timespentData.overallStats.totalStudents : {};
  }

  private get activeStudentsIndex() {
    if (this.$access.isDemoGroup && STUDENT_TIMESPENT_DATA[this.groupType]) {
      return STUDENT_TIMESPENT_DATA[this.groupType].index;
    }
    return this.groupType === 'class' ?
      this.classTimespentData && this.classTimespentData.overallStats ?
        this.classTimespentData.overallStats.activeStudentsIndex : 0 :
      this.timespentData && this.timespentData.overallStats ?
        this.timespentData.overallStats.activeStudentsIndex : 0;
  }

  // ------------------------------------------------------------
  // Properties

  @Prop()
  private selectedDate?: string;

  @Prop()
  private timespentData!: TimespentData;

  @Prop()
  private classTimespentData!: ClassTimespentData;

  @Prop()
  private groupType!: string;

  @Prop()
  private groupId!: string;

  @Prop()
  private lastMonth!: string;

  @Prop({ default: false })
  private isLoading!: boolean;

  @Prop()
  private isAtInitialLevel!: boolean;

  @Prop()
  private isDemoTenant!: boolean;

  @Prop()
  private groupLabel!: string;

  @Prop()
  private currentMonth!: string;

  @Prop()
  private comparativeGain!: { gain: number; percent: number; across: string };

  @Prop()
  private subjectList!: SubjectModel[];


  private selectedLevel?: DrillDownModel;


  private isShowCompetency: boolean = false;

  private isShowTimespentPullup: boolean = false;

  private isGuestPullup: boolean = false;

  private isShowClassProgressReport: boolean = false;

  private classReportLevel: any = null;

  private activeSubject: SubjectModel | any = this.subjectList ? this.subjectList[0] : null;

  @Prop({ default: false })
  private isRestrictClass!: boolean;

  @Prop()
  private activeYear!: string;

  @Prop()
  private activeMonth!: string;

  @Prop()
  private selectedSubject!: any;

  public formatTime(time: number) {
    return formatTimeInMilliSec(time);
  }

  private onCloseTsPullup() {
    this.isShowTimespentPullup = false;
    this.isGuestPullup = false;
    this.isShowClassProgressReport = false;
  }

  private onSelectLevel(level: any, subject: any, pullUp: any) {
    this.selectedLevel = level;
    this.$emit('onSelectLevel', level, subject, pullUp);
  }

  private onSelectSubject(subject: any) {
    this.activeSubject = subject;
    this.$emit('onSelectLevel', this.selectedLevel, subject, 'timespent');
  }

  private onToggleTsPullup() {
    if (this.isGuestUser) {
      this.isGuestPullup = true;
      return;
    }
    this.isShowTimespentPullup = !this.isShowTimespentPullup;
    this.activeSubject = this.subjectList.length ? this.subjectList[0] : null;

  }

  private onSelectClassReport(level: any) {
    this.isShowClassProgressReport = true;
    this.classReportLevel = level;
  }

  private onGoUpward(subject: any, data: any, active: any) {
    this.$emit('onGoUpward', subject, data, active);
  }

  // ---------------------------------------------------------------
  // Hooks

  // ----------------------------------------------------------------
  // Methods

  private numberFormat(value: number) {
    return numberFormat(value);
  }


}
